import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isServer } from 'tradera/utils/nextjs';
import { CookieUtil } from 'tradera/utils/cookie';
import {
    getCookieFromBrowser,
    setCookieToBrowser
} from 'tradera/utils/cookie-helpers';
import { createSelector } from '@reduxjs/toolkit';

export const useCookieUtil = () => {
    const serverCookies = useSelector(
        createSelector(
            (state) => state.request?.cookies,
            (cookies) => cookies ?? {}
        )
    );

    const getCookie = useCallback(
        (key) => {
            if (isServer) {
                return serverCookies[key] || null;
            }
            return getCookieFromBrowser(key);
        },
        [serverCookies]
    );

    const setCookie = useCallback((cookie) => {
        if (isServer) {
            throw new Error('Cannot set cookie on server using this hook');
        } else {
            setCookieToBrowser(cookie);
        }
    }, []);

    const cookieUtil = useMemo(
        () => new CookieUtil(getCookie, setCookie),
        [getCookie, setCookie]
    );

    return cookieUtil;
};
